import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import Slider from "react-slick"

import { ButtonGroup, Button, Row, Col } from "react-bootstrap"
import Section from "./section"

const Events = ({ view, content }) => {
  const settings = {
    infinite: false,
    arrow: true,
    fadeIn: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const {
    field_subhead,
    field_heading,
    field_cta,
    field_desc,
    relationships,
    anchor,
  } = content

  const moment = require("moment-timezone")
  const tz = "Australia/Sydney"

  const data = useStaticQuery(QUERY)

  const dateFilters = [
    {
      date: "24/11/2022",
      hex: false,
    },
    {
      date: "16/07/2021",
      hex: false,
    },
    {
      date: "28/08/2021",
      hex: false,
    },
    {
      date: "29/08/2021",
      hex: false,
    },
  ]


  const defaultDate = () => {
    let today = dateFilters[0]

    dateFilters.map(date => {
      if (date.date === moment().format("DD/MM/YYYY")) {
        today = date
      }
    })

    return today
  }



  const [selectedDay, setSelectedDay] = useState(defaultDate())

  const [overlayData, setOverlayData] = useState(false)

  const [isHex, setIsHex] = useState(defaultDate().hex)

  const openOverlay = index => {
    setOverlayData(data.allNodeEvent.nodes[index])
  }

  const renderOverlay = () => {
    const {
      title,
      body,
      field_date_time,
      field_session_end,
      field_link,
      field_medium,
      relationships,
    } = overlayData

    const start = moment(field_date_time)
    const end = moment(field_session_end)
    const duration = end.diff(start, "minutes")

    return (
      <Row class="d-flex">
        <Col xs={12} md={6} lg={5}>
          <div className="overlay__image">
            {field_medium === 1 && <div class="tag">In Person</div>}
            {field_medium === 2 && <div class="tag">Online</div>}
            {field_medium === 3 && <div class="tag">In person &amp; Online</div>}
            {overlayData.relationships.field_image !== null && (
              <img
                src={
                  relationships.field_image.relationships.field_media_image
                    .localFile.childImageSharp.fixed.src
                }
                alt="Event image"
                className="img-fluid"
              />
            )}
          </div>
        </Col>

        <Col className="d-flex flex-column">
          <div className="overlay__heading">{title}</div>
          <div className="overlay__subhead d-flex justify-content-between align-items-center">
            <div className="event__date-session">
              {start.tz(tz).format("hh:mma") +
                ` - ` +
                end.tz(tz).format("hh:mma")}
            </div>
            <div className="event__date-duration">{duration} mins</div>
          </div>
          <div
            className="overlay__body"
            dangerouslySetInnerHTML={{ __html: body.processed }}
          ></div>
          {(!!relationships.field_download || !!field_link) && (
            <div className="overlay__footer d-flex mt-auto justify-content-between">
              {!!field_link && (
                <Button variant="primary" href={field_link.uri}>
                  Book Event
                </Button>
              )}
              {!!relationships.field_download && (
                <Button
                  variant="primary"
                  className="cta-cal"
                  href={
                    relationships.field_download.relationships
                      .field_media_document.localFile.publicURL
                  }
                ></Button>
              )}
            </div>
          )}
        </Col>
      </Row>
    )
  }

  const renderEventItem = (event, index) => {
    const {
      field_date_time,
      field_session_end,
      field_medium,
      title,
      body,
      relationships,
    } = event

    const bodyTrimmed = body.processed.substring(0, 120) + "..."
    const start = moment(field_date_time)
    const end = moment(field_session_end)
    const duration = end.diff(start, "minutes")

    return (
      <div className="events-list__item d-flex flex-column">
        <div className="event__date d-flex justify-content-between align-items-center">
          <div className="event__date-session">
            {start.tz(tz).format("hh:mma") +
              ` - ` +
              end.tz(tz).format("hh:mma")}
          </div>
          <div className="event__date-duration">{duration} mins</div>
        </div>
        <div className="d-flex">
          {relationships.field_image !== null && (
            <div className="event__image w-50">
              {field_medium === 1 && <div class="tag">In Person</div>}
              {field_medium === 2 && <div class="tag">Online</div>}
              {field_medium === 3 && (
                <div class="tag">In person &amp; Online</div>
              )}

              <img
                src={
                  relationships.field_image.relationships.field_media_image
                    .localFile.childImageSharp.fixed.src
                }
              />
            </div>
          )}
          <div className="w-50">
            <div className="event__title">{title}</div>
{/*
            <div
              className="event__desc"
              dangerouslySetInnerHTML={{ __html: bodyTrimmed }}
            ></div>
              */}
          </div>
        </div>

        <div className="event__cta mt-auto d-flex justify-content-between">
          <Button
            className="cta-more"
            size="sm"
            onClick={() => openOverlay(index)}
          >
            Find out more
          </Button>
          {!!relationships.field_download && (
            <Button
              variant="primary"
              className="cta-cal"
              size="sm"
              href={
                relationships.field_download.relationships.field_media_document
                  .localFile.publicURL
              }
            ></Button>
          )}
        </div>
      </div>
    )
  }

  const renderPlaylistItem = (event, index) => {
    //    const bodyTrimmed = event.body.processed.substring(0, 300)+'...';
    const bodyTrimmed = event.body.processed
    const start = moment(event.field_date_time).subtract(15, "minutes")
    const end = moment(event.field_session_end).add(15, "minutes")

    var isLive = false
    var playClass = " "

    // event is in future
    if (moment().isBetween(start, end)) {
      playClass += "playlist-item__now-playing"
      isLive = true
    } else if (moment().isAfter(end)) {
      playClass += "playlist-item__completed"
    }

    return (
      <Row className={"playlist-item d-flex align-items-center" + playClass}>
        <Col xs={12} md={4} lg={3} xl={2}>
          {isLive && (
            <div className="playlist-item__thumb">
              <div className="playlist-item__live-status">Now playing</div>
              <a href={event.field_link.uri}>
                <Img
                  fluid={
                    event.relationships.field_image.relationships
                      .field_media_image.localFile.childImageSharp.fluid
                  }
                />
              </a>
            </div>
          )}
          {!isLive && (
            <div className="playlist-item__time">
              {moment(event.field_date_time).tz(tz).format("hh:mma")}

              {!!event.field_session_end
                ? ` - ` +
                  moment(event.field_session_end).tz(tz).format("hh:mma")
                : ""}
            </div>
          )}
        </Col>
        <Col>
          <div className="playlist-item__desc">
            <div className="playlist-item__title">{event.title}</div>
            <div
              className="playlist-item__body"
              dangerouslySetInnerHTML={{ __html: bodyTrimmed }}
            ></div>
          </div>
        </Col>
      </Row>
    )
  }

  const renderResourceItem = (event, index) => {
    const bodyTrimmed = event.body.processed

    return (
      <Row className="resource-item d-flex align-items-center">
        <Col xs={12} md={4} lg={3} xl={2}>
          <div className="event__thumb">
            {event.relationships.field_video && (
              <a
                href={event.relationships.field_video.field_media_oembed_video}
              >
                <Img
                  fluid={
                    event.relationships.field_image.relationships
                      .field_media_image.localFile.childImageSharp.fluid
                  }
                />
              </a>
            )}
            {!event.relationships.field_video && (
              <Img
                fluid={
                  event.relationships.field_image.relationships
                    .field_media_image.localFile.childImageSharp.fluid
                }
              />
            )}
          </div>
        </Col>
        <Col>
          <div className="event__desc">
            <div className="event__title">{event.title}</div>
            <div className="event__date d-flex justify-content-between align-items-center">
              {moment(event.field_date_time)
                .tz(tz)
                .format("hh:mma DD MMM YYYY")}
            </div>
            <div
              className="event__body"
              dangerouslySetInnerHTML={{ __html: bodyTrimmed }}
            ></div>
          </div>
        </Col>
      </Row>
    )
  }

  if (view === "playlist") {
    return (
      <>
        <Section name="events-playlist" bg="white">
          <h1 className="text-center">
            Event <span class="pink">Playlist</span>
          </h1>

          <div className="section__events-playlist-date">
            {moment(selectedDay).format("DD MMMM YYYY")}
          </div>

          <ButtonGroup className="section__events-playlist-date-selector d-flex flex-fill">
            {dateFilters.map((date, index) => (
              <Button
                key={index}
                variant={
                  date.date === selectedDay.date
                    ? "primary"
                    : "outline-secondary"
                }
                onClick={() => {
                  setSelectedDay(date)
                  setIsHex(date.hex)
                }}
              >
                Day {index + 1}
              </Button>
            ))}
          </ButtonGroup>

          <p>*All time shown are in AEST</p>

          <div className="events-playlist__items">
            {data.allNodeEvent.nodes.map(
              (node, nid) =>
                moment(node.field_date_time).tz(tz).format("DD/MM/YYYY") ===
                  selectedDay.date && renderPlaylistItem(node, nid)
            )}
          </div>
        </Section>
      </>
    )
  } else if (view === "resourcelist") {
    return (
      <>
        <Section name="events-playlist" bg="white">
          <h1 className="text-center">
            Event <span class="pink">Playlist</span>
          </h1>

          <div className="section__events-playlist-date">
            23 - 24 September 2020
          </div>

          <p>*All time shown are in AEST</p>

          <div className="events-playlist__items">
            {data.allNodeEvent.nodes.map((node, nid) =>
              renderResourceItem(node, nid)
            )}
          </div>
        </Section>
      </>
    )
  }

  return (
    <>
      <Section
        name="events"
        id={anchor}
        heading={field_heading}
        subhead={field_subhead}
      >
        {!!field_desc && (
          <div
            className="page__blurb text-left"
            dangerouslySetInnerHTML={{ __html: field_desc.processed }}
          ></div>
        )}
{/*
        <div className="events-list__date-selectors d-flex flex-column flex-lg-row justify-content-center ">
          {/*dateFilters.map((date, index) => (
            <Button
              key={index}
              variant={date.date === selectedDay.date ? "secondary" : "primary"}
              onClick={() => {
                setSelectedDay(date)
                setIsHex(date.hex)
              }}
            >
              <span className="day">Day {index + 1}</span>
              <span className="date">{date.date}</span>
            </Button>
          ))}

          {!!field_cta && (
            <Button
              variant="primary"
              className="btn-submit"
              href={field_cta.uri}
            >
              {field_cta.title}
            </Button>
          )}
        </div>
        <div className="events-list__heading">
          Event schedule:{" "}
          {moment(selectedDay.date, "DD/MM/YYYY").format("dddd, MMMM Do, YYYY")}
        </div>*/}


        <Row className="events-list d-none d-md-flex" noGutters>
          {data.allNodeEvent.nodes.map(
            (node, nid) =>
              moment(node.field_date_time).tz(tz).format("DD/MM/YYYY") ===
                selectedDay.date && (
                <Col xs={12} md={6} lg={4} className="d-flex" key={nid}>
                  {renderEventItem(node, nid)}
                </Col>
              )
          )}
        </Row>

        {data.allNodeEvent.nodes.length > 0 && (
          <div className="list-slider">
            <Slider {...settings}>
              {data.allNodeEvent.nodes.map(
                (node, index) =>
                  moment(node.field_date_time).tz(tz).format("DD/MM/YYYY") ===
                    selectedDay.date && (
                    <div className="slide" key={index}>
                      {renderEventItem(node, index)}
                    </div>
                  )
              )}
            </Slider>
          </div>
        )}

        {overlayData && (
          <div className="overlay overlay__event d-flex flex-column justify-content-center align-items-center">
            <div className="overlay__inner">
              <div className="overlay__close">
                <a onClick={e => setOverlayData(false)}>Close</a>{" "}
              </div>
              {renderOverlay()}
            </div>
          </div>
        )}
      </Section>
    </>
  )
}

export default Events

const QUERY = graphql`
  query {
    allNodeEvent(sort: { fields: field_date_time, order: ASC }) {
      nodes {
        body {
          processed
        }
        title
        field_date_time
        field_session_end
        field_link {
          uri
        }
        field_medium
        relationships {
          field_image {
            relationships {
              field_media_image {
                localFile {
                  childImageSharp {
                    fixed {
                      src
                    }
                  }
                }
              }
            }
          }
          field_download {
            relationships {
              field_media_document {
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  }
`
